// แปล HTTP status code เป็นคำอธิบายภาษาไทยที่ user ทั่วไป (ไม่รู้ภาษาอังกฤษ/ไม่รู้จัก HTTP) อ่านแล้วเข้าใจ
// ว่าเกิดอะไรขึ้น — ใช้ร่วมกันทั้ง GlobalErrorDialog.js (error จาก axios interceptor/unhandled rejection)
// และ GlobalAlertDialog.js (error จาก showAlert(msg, {status}) ที่เรียกเองในแต่ละหน้า)
// code = null หมายถึง "ไม่มี response กลับมาเลย" (เน็ตหลุด/เซิร์ฟเวอร์ไม่ตอบ) ไม่ใช่ error จาก backend จริงๆ
const STATUS_THAI = {
  400: 'ข้อมูลที่ส่งไปไม่ถูกต้องหรือไม่ครบถ้วน กรุณาตรวจสอบข้อมูลอีกครั้ง',
  401: 'คุณยังไม่ได้เข้าสู่ระบบ หรือเซสชันหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
  403: 'คุณไม่มีสิทธิ์เข้าถึงหรือทำรายการนี้',
  404: 'ไม่พบข้อมูลหรือรายการที่ต้องการ อาจถูกลบหรือย้ายไปแล้ว',
  405: 'ระบบไม่รองรับการทำรายการนี้ในรูปแบบที่ส่งมา',
  406: 'ระบบไม่สามารถส่งข้อมูลในรูปแบบที่ร้องขอได้',
  408: 'การเชื่อมต่อใช้เวลานานเกินไป กรุณาลองใหม่อีกครั้ง',
  409: 'ข้อมูลขัดแย้งกับข้อมูลที่มีอยู่แล้วในระบบ',
  410: 'ข้อมูลนี้ถูกลบออกจากระบบแล้ว',
  413: 'ไฟล์หรือข้อมูลที่ส่งมีขนาดใหญ่เกินกำหนด กรุณาลดขนาดไฟล์แล้วลองใหม่',
  414: 'ลิงก์หรือคำขอที่ส่งมายาวเกินไป',
  415: 'ประเภทไฟล์ที่แนบมาไม่รองรับ',
  422: 'ข้อมูลที่กรอกไม่ถูกต้องตามเงื่อนไขที่ระบบกำหนด',
  423: 'ข้อมูลนี้ถูกล็อกไว้ ไม่สามารถแก้ไขได้ในขณะนี้',
  429: 'ทำรายการถี่เกินไป กรุณารอสักครู่แล้วลองใหม่อีกครั้ง',
  500: 'เกิดข้อผิดพลาดที่ระบบเซิร์ฟเวอร์ กรุณาลองใหม่อีกครั้ง หรือแจ้งผู้ดูแลระบบหากยังพบปัญหา',
  501: 'ระบบยังไม่รองรับฟังก์ชันนี้',
  502: 'เซิร์ฟเวอร์ไม่ตอบสนอง กรุณาลองใหม่อีกสักครู่',
  503: 'ระบบไม่พร้อมให้บริการชั่วคราว กรุณาลองใหม่อีกสักครู่',
  504: 'เซิร์ฟเวอร์ใช้เวลาตอบสนองนานเกินไป กรุณาลองใหม่อีกครั้ง',
};

const NETWORK_ERROR_TEXT = 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่อีกครั้ง';
const TIMEOUT_TEXT = 'การเชื่อมต่อใช้เวลานานเกินไป กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่อีกครั้ง';
const DB_CONNECTION_TEXT = 'ระบบไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์หรือฐานข้อมูลได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง หรือแจ้งผู้ดูแลระบบหากยังพบปัญหา';
const APP_BUG_TEXT = 'เกิดข้อผิดพลาดในระบบ กรุณาลองใหม่อีกครั้ง หากยังพบปัญหากรุณาแจ้งทีมพัฒนา';
const UNKNOWN_ERROR_TEXT = 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาลองใหม่อีกครั้ง';

// มี Thai unicode range อยู่ในข้อความหรือไม่ — ใช้เดาว่าข้อความนี้ backend/validation ตั้งใจเขียนให้ user
// อ่านอยู่แล้ว (เช่น "งบประมาณที่เลือกไม่ตรงกับโครงการ") ต่างจาก error ทางเทคนิคดิบๆ ที่เป็นอังกฤษล้วน
const hasThai = (text) => /[฀-๿]/.test(text);

// คืนคำอธิบายภาษาไทยของ status code — ไม่รู้จัก code (เช่น 4xx/5xx แปลกๆ ที่ไม่ได้ list ไว้) ให้เดา
// ตามช่วงเลข (4xx = ปัญหาจากฝั่งคำขอ, 5xx = ปัญหาจากฝั่งเซิร์ฟเวอร์) แทนที่จะโชว์ข้อความไม่รู้เรื่องเฉยๆ
export function translateHttpStatus(code) {
  if (code == null) return NETWORK_ERROR_TEXT;
  if (STATUS_THAI[code]) return STATUS_THAI[code];
  if (code >= 400 && code < 500) return 'คำขอนี้มีปัญหา กรุณาตรวจสอบข้อมูลแล้วลองใหม่อีกครั้ง';
  if (code >= 500) return 'เซิร์ฟเวอร์เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง หรือแจ้งผู้ดูแลระบบหากยังพบปัญหา';
  return UNKNOWN_ERROR_TEXT;
}

// สำหรับ error ที่ "ไม่มี" HTTP status เลย (เน็ตหลุด, timeout, DNS ฐานข้อมูลหาไม่เจอ, หรือ JS bug ที่
// unhandledrejection ดักได้) — เดิม error พวกนี้โชว์ raw message ดิบๆ (เช่น "Network Error",
// "TypeError: Cannot read properties of undefined (reading 'map')") ตรงๆ ให้ user อ่าน ซึ่งไม่มีทางเข้าใจ
// ได้เลยถ้าไม่รู้ภาษาอังกฤษ/เทคนิค — เดาจาก pattern ของข้อความดิบว่าเป็น error ประเภทไหน แล้วแปลเป็นไทย
// ที่สื่อความหมายถูกกลุ่ม (เน็ต/timeout/ต่อฐานข้อมูลไม่ได้/บั๊กแอป) แทนการเหมารวมว่าทุกอย่างคือ "เน็ตหลุด"
// เหมือนเดิม (ผิดกลุ่มได้ถ้าจริงๆ เป็นบั๊กโค้ด ไม่ใช่ปัญหาเน็ต) — ถ้าข้อความมีภาษาไทยอยู่แล้วถือว่าเป็นข้อความ
// ที่ backend/validation ตั้งใจเขียนให้ user อ่านอยู่แล้ว ใช้ตามนั้นเลยไม่ต้องเดาซ้ำ
export function translateNonHttpError(message) {
  const text = String(message || '').trim();
  if (!text) return UNKNOWN_ERROR_TEXT;
  if (hasThai(text)) return text;
  if (/network error/i.test(text)) return NETWORK_ERROR_TEXT;
  if (/timeout|ECONNABORTED/i.test(text)) return TIMEOUT_TEXT;
  if (/ENOTFOUND|ECONNREFUSED|ECONNRESET|EAI_AGAIN|getaddrinfo/i.test(text)) return DB_CONNECTION_TEXT;
  if (/is not a function|is not defined|cannot read propert(y|ies)|undefined is not|null is not|unexpected token/i.test(text)) return APP_BUG_TEXT;
  return UNKNOWN_ERROR_TEXT;
}

export default translateHttpStatus;
